import { DSCardWrapper } from "@components/design-system/molecules";
import * as Sentry from "@sentry/react";
import mixpanel from "mixpanel-browser";

function ErrorFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-primary p-md">
      <DSCardWrapper
        variant="danger"
        width="w-auto"
        dataTestId="error-boundary-fallback"
      >
        <div className="flex flex-col items-center gap-md text-center">
          <h2 className="text-lg font-semibold text-primary">
            Something went wrong
          </h2>

          <p className="text-secondary">
            An unexpected error occurred. Please reload the page to
            continue.
          </p>
          <button
            onClick={() => window.location.reload()}
            className="px-lg py-sm bg-brand text-white rounded-md cursor-pointer hover:opacity-90 transition-opacity"
            data-testid="error-boundary-reload-btn"
            data-mx-label="Error Boundary Reload"
          >
            Reload
          </button>
        </div>
      </DSCardWrapper>
    </div>
  );
}

export function ErrorBoundary({ children }) {
  return (
    <Sentry.ErrorBoundary
      fallback={ErrorFallback}
      onError={(error, componentStack) => {
        mixpanel.track("React Error Boundary", {
          error: error?.message || String(error),
          componentStack,
        });
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
